var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend-widget-cell"},[_c('div',{staticClass:"legend-section"},[_c('div',{staticClass:"material-icons",style:({'color': _vm.color})},[_vm._v(" fiber_manual_record ")]),_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])]),_c('div',{staticClass:"value-section"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }